import * as React from "react"
import { IconUsers, IconDeviceDesktop, IconClipboard, IconFileText } from "@tabler/icons-react"

import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/admin/components/ui/card"
import { fetchStats } from '@/admin/data/mock'

export function SectionCards() {
  const [stats, setStats] = React.useState({
    usersCount: 0,
    devicesCount: 0,
    leasesExpiringSoon: 0,
    auditLast24h: 0,
  })
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    fetchStats()
      .then(data => setStats(data))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="*:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card grid grid-cols-1 gap-4 px-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:shadow-xs lg:px-6 @xl/main:grid-cols-2 @5xl/main:grid-cols-4">
      <Card className="@container/card">
        <CardHeader>
          <CardDescription>Total Users</CardDescription>
          <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
            {loading ? '...' : stats.usersCount}
          </CardTitle>
        </CardHeader>
        <CardFooter className="flex-col items-start gap-1.5 text-sm">
          <div className="line-clamp-1 flex gap-2 font-medium">
            <IconUsers className="size-4" /> All registered accounts
          </div>
          <div className="text-muted-foreground">
            Active user base
          </div>
        </CardFooter>
      </Card>
      <Card className="@container/card">
        <CardHeader>
          <CardDescription>Devices Online</CardDescription>
          <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
            {loading ? '...' : stats.devicesCount}
          </CardTitle>
        </CardHeader>
        <CardFooter className="flex-col items-start gap-1.5 text-sm">
          <div className="line-clamp-1 flex gap-2 font-medium">
            <IconDeviceDesktop className="size-4" /> Connected devices
          </div>
          <div className="text-muted-foreground">
            Last 24 hours activity
          </div>
        </CardFooter>
      </Card>
      <Card className="@container/card">
        <CardHeader>
          <CardDescription>Leases Expiring Soon</CardDescription>
          <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
            {loading ? '...' : stats.leasesExpiringSoon}
          </CardTitle>
        </CardHeader>
        <CardFooter className="flex-col items-start gap-1.5 text-sm">
          <div className="line-clamp-1 flex gap-2 font-medium">
            <IconClipboard className="size-4" /> Attention needed
          </div>
          <div className="text-muted-foreground">Within next 48 hours</div>
        </CardFooter>
      </Card>
      <Card className="@container/card">
        <CardHeader>
          <CardDescription>Audit Events</CardDescription>
          <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
            {loading ? '...' : stats.auditLast24h}
          </CardTitle>
        </CardHeader>
        <CardFooter className="flex-col items-start gap-1.5 text-sm">
          <div className="line-clamp-1 flex gap-2 font-medium">
            <IconFileText className="size-4" /> Recent activity
          </div>
          <div className="text-muted-foreground">Last 24 hours</div>
        </CardFooter>
      </Card>
    </div>
  )
}
